import map from 'lodash/map';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import isLimitationsReached from '~/src/features/tariffBuilder/selectors/isLimitationsReached';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const getRouters = (state: TInitialState) => {
    const routers = state[EEntity.routers];

    const limitations = isLimitationsReached(EEntity.routers)(state);

    return map(
        routers,
        ({ costs, selectedCost, quantity, ...router }, key) => {
            const displayedCost = limitations.installment && quantity === 0 ? 1 : selectedCost;
            return ({
                ...router,
                ...costs[displayedCost],
                quantity,
                isSelected: quantity > 0,
                displayedCost,

                key: Number(key),
            });
        },
    );
};

export default getRouters;
